export default function(date){
  if(!date) return ""
  if(typeof date !== "string") return date
  return date.split("-").join("/")
}